<template>
  <div class="container container-table">
      <div class="row vertical-10p">
        <div class="container">
          <div class="text-center col-md-6 col-sm-offset-3">
            <box :title="title">
                <div v-show="!enviou" slot="body">
                    <div class="form-group">
                        <input class="form-control" v-model="email">
                    </div>
                    <div class="form-group">
                        <button class="btn btn-primary" @click="redefinir">
                            <i v-show="gravando" class="fa fa-spinner fa-spin"></i>
                            Redefinir Senha
                        </button><br><br>
                        <router-link to="login">
                            Voltar para Login
                        </router-link>
                        <div v-if="response" class="text-red"><p>{{response}}</p></div>
                    </div>
                </div>
                <div v-show="enviou" slot="body">
                    <div class="text-black">
                        <p>Email de redefinição de senha enviado para <b>{{email}}</b>.</p>
                    </div>
                    <div class="row">
                        <div class="col-sm-2 col-sm-offset-3">
                            <router-link to="login">
                                Login
                            </router-link>
                        </div>
                        <div class="col-sm-4">
                            <a href="javascript:;" @click="enviou = false; title='Informe seu email para redefinir a senha de acesso'">Enviar Novamente?</a>
                        </div>
                    </div>
                </div>
                
            </box>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import router from '../router'
import Box from './views/Box'

export default {
  name: 'RedefinirSenha',
  components: {
      'box': Box
  },
  data () {
    return {
      response: '',
      email: '',
      enviou: false,
      gravando: false,
      title: 'Informe seu email para redefinir a senha de acesso'
    }
  },
  created () {
    
    
  },
  methods: {
    redefinir(){
        this.gravando = true
        var auth = firebase.auth();

        auth.sendPasswordResetEmail(this.email).then(() =>{
            this.emailSent = true
            this.enviou =true
            this.gravando = false
            this.response = ''
            this.title = ''
        }).catch((error) => {
            this.response = error.message
            this.gravando = false
        });
    }
  }
}
</script>

<style>


</style>



// WEBPACK FOOTER //
// RedefinirSenha.vue?27f13fd4